import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-55e44b0a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "offers-wrapper" }
const _hoisted_2 = { class: "map-toggle px-4 py-2" }
const _hoisted_3 = { id: "offers-container" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode("cette offre n'existe plus")

import { ComputedRef, inject, ref } from "vue";
import type { Offer, Partner } from "@emblem/api";
import PartnersWithFilter from "@/components/PartnersWithFilter.vue";
import PartnerCard from "@/components/PartnerCard.vue";
import OffersMap from "@/components/OffersMap.vue";
import { useRoute } from "vue-router";


const __default__ = {
  name: "OffersPage",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const showMap = ref(false);
const currentOfferDialog = ref(false);
const currentOffer = ref<Offer | null>(null);

const partners = inject("partners:list") as ComputedRef<Array<Partner>>;
const route = useRoute();
const findOfferById = (id: string) => {
  for (const partner of partners.value) {
    for (const offer of partner.offers) {
      if (offer._id === id) {
        return offer;
      }
    }
  }
};
if (typeof route.query.show === "string") {
  const offer = findOfferById(route.query.show);
  if (offer) {
    currentOffer.value = offer;
    currentOfferDialog.value = true;
  }
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_overlay = _resolveComponent("v-overlay")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(PartnersWithFilter, { "colored-chips": showMap.value }, {
      default: _withCtx(({ partners }) => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_v_btn, {
              onClick: _cache[0] || (_cache[0] = ($event: any) => (showMap.value = false))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "small",
                  color: !showMap.value ? 'primary' : undefined,
                  icon: "fas fa-list"
                }, null, 8, ["color"])
              ]),
              _: 1
            }),
            _createVNode(_component_v_btn, {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (showMap.value = true))
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_icon, {
                  size: "small",
                  color: showMap.value ? 'primary' : undefined,
                  icon: "fas fa-map-location"
                }, null, 8, ["color"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_3, [
            (showMap.value)
              ? (_openBlock(), _createBlock(OffersMap, {
                  key: 0,
                  partners: partners
                }, null, 8, ["partners"]))
              : (_openBlock(), _createBlock(_component_v_container, { key: 1 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(partners, (partner) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            key: partner._id,
                            cols: "12",
                            class: "pt-0"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(PartnerCard, { partner: partner }, null, 8, ["partner"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 2
                    }, 1024)
                  ]),
                  _: 2
                }, 1024))
          ])
        ])
      ]),
      _: 1
    }, 8, ["colored-chips"]),
    _createVNode(_component_v_overlay, {
      modelValue: currentOfferDialog.value,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((currentOfferDialog).value = $event)),
      class: "current-offer align-center justify-center"
    }, {
      default: _withCtx(() => [
        (currentOffer.value && currentOffer.value.partner)
          ? (_openBlock(), _createBlock(PartnerCard, {
              key: 0,
              partner: currentOffer.value.partner,
              "offer-filter": (offer) => offer._id === currentOffer.value!._id
            }, null, 8, ["partner", "offer-filter"]))
          : (_openBlock(), _createBlock(_component_v_card, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _hoisted_4
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })),
        _createVNode(_component_v_btn, {
          position: "absolute",
          size: "x-small",
          icon: "fas fa-times",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (currentOfferDialog.value = false))
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
}
}

})